export const apiServer =
  process.env.REACT_APP_API_SERVER || 'http://localhost:49786/api';
export const loginTimeout = process.env.REACT_APP_LOGIN_TIMEOUT || 5000;
export const queryTimeout = process.env.REACT_APP_QUERY_TIMEOUT || 20000;
export const baseUrl = process.env.REACT_APP_BASE_URL || '';
export const loginExpiry = process.env.REACT_APP_LOGIN_EXPIRY || 90;
export const remoteDomain = process.env.REACT_APP_REMOTE_DOMAIN;
